import { Component, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { AppService } from 'src/app/server/app.service'
import { MenuItem } from 'src/app/shared/security/passport.model'
import { environment } from "../../../environments/environment"
export let isDebugMode = environment.isDebugMode

@Component({
  selector: 'flow-starter-sidebar',
  templateUrl: './starter-sidebar.component.html',
  styleUrls: ['./starter-sidebar.component.scss']
})
export class StarterSidebarComponent implements OnInit {

  private subscriptions: Subscription[] = []
  themeid: number
  sideBarExpand: boolean = false
  focused: boolean = false
  menuItem: MenuItem[]

  constructor(private appService: AppService) {
    isDebugMode ? console.log(`constructor()`) : undefined
  }

  ngOnInit() {
    isDebugMode ? console.log(`ngOnInit()`) : undefined
    this.themeid = 1
    this.subscriptions.push(
      this.appService.eventSession.subscribe(session => {
        this.themeid = session.themeid
      }),
      this.appService.eventSideBarExpand.subscribe(toggle => {
        this.sideBarExpand = !this.sideBarExpand
      })
    )
  }

  ngAfterViewInit() {
    this.appService.getUserMenu(0).subscribe(items => {
      this.menuItem = items //user[0].menu
    })
  }

  ngOnDestroy() {
    isDebugMode ? console.log(`ngOnDestroy()`) : undefined
    this.subscriptions.forEach(sub => sub.unsubscribe())
  }

  mouseEnter(event) {
    this.focused = true;
  }

  mouseLeave(event) {
    this.focused = false;
  }

  onSelectMenu(item) {

  }

}
